import { useState } from 'react';
import { Avatar } from 'primereact/avatar';
import { Button } from 'primereact/button';
import { Chart } from 'primereact/chart';
import { DataSource } from 'components/DataSource';
import { ProgressBar } from 'primereact/progressbar';
import { Title } from 'components/Title';

export default function AdminPage() {
	
	const [pageReady, setPageReady] = useState(true);
	return (
		<main id="AdminPage" className="main-page">
<section className="page-section q-pa-md" >
    <div className="container-fluid">
        <div className="grid ">
            <div className="col comp-grid" >
                <Title title="Admin"   titleClass="text-lg font-bold text-primary" subTitleClass="text-500"      separator={false} />
                <section className="page-section mb-3" >
                    <div className="container-fluid">
                        <div className="grid ">
                            <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                <div className="">
                                    <DataSource   apiPath="components_data/admin_data_component" firstRecord={true} showLoading={false}>
                                        {
                                        ({ response, loading, reload }) => 
                                        <>
                                        <div >
                                            <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                <div className="flex align-items-center gap-3">
                                                    <div style={{width:'auto'}}>
                                                        <Avatar icon="pi pi-th-large" size="large" className="bg-primary text-white" />
                                                        </div>
                                                        <div>
                                                            <div className="font-medium text-lg">Total Student</div>
                                                            {loading && 
                                                            <div className="p-2">
                                                                <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                            </div>
                                                            }
                                                            {response && 
                                                            <div className="font-bold"> {JSON.stringify(response.stu_cou)}</div>
                                                            }
                                                        </div>
                                                    </div>
                                                    <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                        <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                    </div>
                                                </div>
                                            </div>
                                            </>
                                            }
                                        </DataSource>
                                    </div>
                                </div>
                                <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                    <div className="">
                                        <DataSource   apiPath="components_data/admin_data_component_2" firstRecord={true} showLoading={false}>
                                            {
                                            ({ response, loading, reload }) => 
                                            <>
                                            <div >
                                                <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                    <div className="flex align-items-center gap-3">
                                                        <div style={{width:'auto'}}>
                                                            <Avatar icon="pi pi-th-large" size="large" className="bg-primary text-white" />
                                                            </div>
                                                            <div>
                                                                <div className="font-medium text-lg">Total Enrolled</div>
                                                                {loading && 
                                                                <div className="p-2">
                                                                    <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                                </div>
                                                                }
                                                                {response && 
                                                                <div className="font-bold"> {JSON.stringify(response.enrolled)}</div>
                                                                }
                                                            </div>
                                                        </div>
                                                        <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                            <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                        </div>
                                                    </div>
                                                </div>
                                                </>
                                                }
                                            </DataSource>
                                        </div>
                                    </div>
                                    <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-3 md:col-3 comp-grid" >
                                        <div className="">
                                            <DataSource   apiPath="components_data/admin_data_component_3" firstRecord={true} showLoading={false}>
                                                {
                                                ({ response, loading, reload }) => 
                                                <>
                                                <div >
                                                    <div className="card bg-blue-200 text-blue-600 nice-shadow-6 relative">
                                                        <div className="flex align-items-center gap-3">
                                                            <div style={{width:'auto'}}>
                                                                <Avatar icon="pi pi-th-large" size="large" className="bg-primary text-white" />
                                                                </div>
                                                                <div>
                                                                    <div className="font-medium text-lg">Total Payments</div>
                                                                    {loading && 
                                                                    <div className="p-2">
                                                                        <ProgressBar mode="indeterminate" style={{height: '6px'}}></ProgressBar>
                                                                    </div>
                                                                    }
                                                                    {response && 
                                                                    <div className="font-bold"> {JSON.stringify(response.amt)}</div>
                                                                    }
                                                                </div>
                                                            </div>
                                                            <div style={{position:'absolute', right:'10px', top:'10px'}}>
                                                                <Button className="p-button-text p-button-plain" onClick={() => reload()} icon="pi pi-refresh" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                            <section className="page-section mb-3" >
                                <div className="container-fluid">
                                    <div className="grid ">
                                        <div className="col-sm-4 col-md-4 col-12 sm:col-1 lg:col-6 md:col-4 comp-grid" >
                                            <div className="card  s">
                                                <div className="q-pa-md">
                                                    <div className="font-bold text-lg">Enrollment</div>
                                                    <div className="text-500"></div>
                                                    <hr />
                                                    <div className="row q-col-gutter-sm">
                                                        <div className="col">
                                                            <DataSource   apiPath="components_data/barchart_enrollment"  >
                                                                {
                                                                ({ response }) => 
                                                                <>
                                                                <Chart data={response} type="bar" options={{
                                                                scales: {
                                                                y: {
                                                                title: {
                                                                display: true,
                                                                text: ""
                                                                }
                                                                },
                                                                x: {
                                                                title: {
                                                                display: true,
                                                                text: ""
                                                                }
                                                                }
                                                                }
                                                                }
                                                                }  />
                                                                </>
                                                                }
                                                            </DataSource>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>
                        </div>
                    </div>
                </div>
            </section>
		</main>
	);
}
